import React, {useEffect} from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import Sidebar from "./Sidebar";
import Navbar from "./Navbar";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import { Outlet } from 'react-router-dom'; 
import '../pages/admin/admin.css';
import '../pages/admin/new.css';
const AdminLayout = (props) => {

    let navigate = useNavigate();
    // const userdata = useSelector((store) => store.userReducer.userdata);

    useEffect(() => {
                // if (userdata && Object.keys(userdata).length > 0) {
                //   //   fetchdata();
                  
                // } else {
                //   navigate("/admin/login");
                // }
              }, []);
    return (
       <div className="mainlayout-maindiv-admin">
            <div className="mainlayout-leftdiv">
                <Sidebar />
            </div>
            <div className="mainlayout-rightdiv">
                <div className="mainlayout-navbar">
                    <Navbar title={props?.title} />
                </div>
                <div className="mainpage create-mainpage">
                    {props.children}
                </div>
            </div>
       </div>
    )
}

export default AdminLayout